import React from 'react';
import {
  FDStack,
  FDIcon,
  FDLozenge, FDBodyText,
} from '@facet-wealth/design';
import { buildFacetDesignOverrideLite, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import MetaControl from 'Components/UI/Meta/MetaControl';

const metaOverrides = buildFacetDesignOverrideLite()
  .nameOverride(['primaryText'], {
    _component: () => FDBodyText,
    _customProps: {
      size: 'md',
    },
  }, overrideReadOnly);

const UpgradeOfferListItem = ({ item }) => {
  return (
    <FDStack direction={'row'} spacing={1} alignItems={'center'}>
      <FDIcon icon={item.attr('icon')} size={'sm'} />
      <MetaControl attrName={'primaryText'} resource={item} metaOverrideSet={metaOverrides} flex={1} />
      {item.attr('lozengeText')
        ? <FDLozenge label={item.attr('lozengeText')} color={'info'} />
        : null}
    </FDStack>
  );
};

export { UpgradeOfferListItem };
